const initialProjects = [
  {
    id: 1,
    title: "Todo App",
    description: "A simple task management application built with React.",
    tech: ["React", "CSS", "LocalStorage"],
  },
  {
    id: 2,
    title: "Weather Dashboard",
    description: "Real-time weather tracking using OpenWeather API.",
    tech: ["React", "API", "Axios"],
  },
  {
    id: 3,
    title: "E-commerce Store",
    description: "Full-featured shopping cart with Redux state management.",
    tech: ["React", "Redux", "Stripe"],
  },
];

const initialState = {
  projects: initialProjects,
  filteredProjects: initialProjects,
  messages: [],
};

export const FILTER_PROJECTS = 'FILTER_PROJECTS';
export const ADD_MESSAGE = 'ADD_MESSAGE';

export const portfolioReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTER_PROJECTS:
      const query = action.payload.toLowerCase();
      return {
        ...state,
        filteredProjects: state.projects.filter(project =>
          project.title.toLowerCase().includes(query)
        ),
      };
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    default:
      return state;
  }
};